import React from 'react';
import {
  ListItemIcon,
  ListItemText,
  useTheme,
  makeStyles,
  Collapse,
  Divider,
  List
} from '@material-ui/core';
import clsx from 'clsx';
import { styles } from './sideNavItem.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ListItemLink } from '../../../../shared';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface SideNavItemProps {
  name: string;
  link?: string;
  icon?: IconProp;
  items?: SideNavItemProps[];
  sideNavOpen?: boolean;
  isSubitem?: boolean;
}

const SideNavItem: React.FC<SideNavItemProps> = ({
  name,
  link = '',
  icon,
  items = [],
  sideNavOpen = false,
  isSubitem = false
}) => {
  const { t } = useTranslation('sideNav');

  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  let location = useLocation();

  const isExpandable = items && items.length > 0;
  const isSelected = link === location.pathname;
  const isChildSelected = !!items.find(x => x.link === location.pathname);

  const handleClick = React.useCallback(() => {
    setOpen(!open);
  }, [open]);

  const SideNavItemRoot = (
    <ListItemLink
      button
      onClick={handleClick}
      to={isExpandable ? '' : link}
      classNameNavItem={classes.sideNavItem}
      className={clsx({
        [classes.sideNavItemSelected]: !isSubitem && (isSelected || isChildSelected),
        [classes.sideNavSubitemSelected]: isSubitem && (isSelected || isChildSelected),
        [classes.sideNavSubitem]: isSubitem
      })}
    >
      {!!icon && (
        <ListItemIcon className={classes.menuItemIcon}>
          <FontAwesomeIcon icon={icon} fixedWidth />
        </ListItemIcon>
      )}
      <ListItemText
        disableTypography
        className={classes.menuItemText}
        primary={t(`sideNav:${name}`)}
        inset={!icon}
      />
      {isExpandable && !open && <FontAwesomeIcon icon="chevron-down" />}
      {isExpandable && open && <FontAwesomeIcon icon="chevron-up" />}
    </ListItemLink>
  );

  const SideNavItemChildren = isExpandable ? (
    <Collapse in={open && sideNavOpen} timeout="auto" unmountOnExit>
      <Divider />
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <SideNavItem {...item} key={index} isSubitem={true} />
        ))}
      </List>
    </Collapse>
  ) : null;

  return (
    <>
      {SideNavItemRoot}
      {SideNavItemChildren}
    </>
  );
};

export default SideNavItem;
